"use strict";

angular.module('app.controllers.favorites', []).//
config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('favorites', {
        parent: 'site',
        url: '/favorites/:favoriteId',
        templateUrl: 'views/favorites.html',
        controller: 'FavoritenCtrl',
        breadcrumb: {
            initialState: true,
            name: 'NAV_Favorites'
        },
        resolve: {
            Favorites: function (__Favorite) {
                'ngInject';

                return __Favorite.$getAll({'WithDetails':true}).$asPromise();
            }
        },
        infoGuide : {
            state: 'favorites'
        }
    });
}]).
controller("FavoritenCtrl",
    [
        '$rootScope', '$scope', '$filter', 'f_Interval', '$q', 'Favorites', 'xCenterConfig', 'viewMenuBarService', '__MenuEntry', '__Favorite', 'API', '__Device', 'deviceRoomPickerModal', 'f_Devices', 'DeviceTypes', 'ENUM',
        function($rootScope, $scope, $filter, f_Interval, $q, Favorites, xCenterConfig, viewMenuBarService, __MenuEntry, __Favorite, API, __Device, deviceRoomPickerModal, f_Devices, DeviceTypes, ENUM) {

            // Init Vars
            var favoriteObject =
            {
                favoriteType : 'MenuEntry',
                favoriteObject:
                __MenuEntry.$buildRaw({
                    "$type" : "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared",
                    "MenuEntryId": '00000000-0000-0000-0000-000000000006',
                    "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                    "DeviceId": '00000000-0000-0000-0000-000000000000',
                    'CustomActionName': 'FavoriteOverview',
                    'DisplayName': 'Favoriten',
                    'ImageName': 'favorit',
                    'CustomActionDatas': {
                        '$type': "System.Collections.Generic.List`1[[System.String, mscorlib]], mscorlib",
                        '$values': ['00000000-0000-0000-0000-000000000006']
                    },
                    $UI:{}
                })
            };
            viewMenuBarService.setFavorite(favoriteObject);
            $scope.pageClass = 'Favorites';
            $scope.Favorites = [];
            $scope.reorder = false;
            $scope.f_Devices = f_Devices;
            $scope.DeviceTypes = DeviceTypes['BMSDeviceType']['1AsKey'];

            $scope.rootScope = $rootScope;

            // newMax is for reorderung, so the list won't be cut if user has pressed add row

            $scope.updateFavorites = function(data,newMax){
               // console.log($scope.Favorites);
                //console.log(data);
                $scope.menu = [];
                //var l = _.each( angular.copy(data.$encode()),function(a){ delete a.$type; return a;} );
                //$scope.Favorites = angular.merge( $scope.Favorites, l );

                for (var i = $scope.Favorites.length-1; i >= 0; i--) {
                    // Remove Favorites from list which where deleted in the meantime


                    var found = -1;
                    for(var j =  data.length-1; j >= 0; j--)
                    {
                       // console.log(data[j].FavoriteId + '----'+ $scope.Favorites[i].FavoriteId);
                        if(data[j].FavoriteId === $scope.Favorites[i].FavoriteId)
                        {
                            found = j;
                        }
                    }




                    if (found == -1 ) {
                        //console.log('Splice', $scope.Favorites[i].DisplayName);
                        $scope.Favorites.splice(i, 1);
                        continue;
                    } else {
                        // update Favorite
                        //console.log('Update', $scope.Favorites[i].DisplayName);
                       // console.log(data[found]);
                       // console.log($scope.Favorites[i]);
                        $scope.Favorites[i].updateFavoriteData( data[found] );
                        data.splice(found, 1);
                    }
                };
                for (let i = 0; i < data.length; i++) {
                    const elem = data[i];
                    $scope.Favorites.push(elem);
                }
                // _.each(data, function (a) {
                //   //  console.log('Add', a.DisplayName);
                //     $scope.Favorites.push(a);
                // });

                $scope.generateList(newMax);

            }


            $scope.generateList = function( skipNewMax ){
                if($scope.Favorites.length > 0){
                    // Generate Grid
                    $scope.menu = [];

                    var max = 0;
                    for(var i = 0; i< $scope.Favorites.length; i++)
                    {
                        if($scope.Favorites[i].ShowOnStartScreen && $scope.Favorites[i].Position > max)
                        {
                            max = parseInt($scope.Favorites[i].Position);
                        }
                    }
                    var maxPosition = max;

                    maxPosition = ((  Math.ceil(( maxPosition + 1 ) / 5) ) * 5 );

                    if(skipNewMax && $scope.lastMaxPosition){
                        maxPosition = $scope.lastMaxPosition ;
                    }

                    $scope.lastMaxPosition = maxPosition;
                    for (var i = 0; i < maxPosition; i++) {
                        $scope.menu.push(
                            {
                                "NewFavorite": [],
                                "Favorite": $filter('filter')($scope.Favorites, {"Position": i,ShowOnStartScreen:true}, true),
                                "Position": i
                            }
                        );
                    }
                    $scope.FavoritesNotOnStartScreen = $filter('orderBy')($filter('filter')( $scope.Favorites , {ShowOnStartScreen:false}, true) , '+Position');

                    printPositionInfo('No sort:');
                }
            }

            function setMainViewProperties() {

                $scope.aussenTemp = $scope.Favorites.$getByUIID('OutsideTemperature');
                if ($scope.aussenTemp) {
                    $scope.aussenTemp.$UI.Device = f_Devices.getById($scope.aussenTemp.DeviceId);
                }
                $scope.isPresent = $scope.Favorites.$getByUIID('IsPresent');
            }

            function initFavoritesUpdateInterval() {
                if (xCenterConfig.interval.homescreenFavoriteValues > 0) {
                    if($scope.favoritesintervall) {
                        f_Interval.unregisterIntervalByAppId($scope.favoritesintervall);
                    }

                    var intervalConfig = {
                        'AppId': 'interval.homescreen',
                        delay: xCenterConfig.interval.homescreenFavoriteValues,
                        fn: function () {
                            var defer = $q.defer();
                            __Favorite.$getAll({'WithDetails':true}).$then(function (data) {

                                for (let i = $scope.Favorites.length - 1; i >= 0; i--) {
                                    // Remove Favorites from list which where deleted in the meantime
                                    var found = data.findIndex(a => {
                                        return a.FavoriteId === $scope.Favorites[i].FavoriteId;
                                    });
                                    if (found === -1) {
                                        $scope.Favorites.splice(i, 1);
                                    } else {
                                        // update Favorite
                                        $scope.Favorites[i].updateFavoriteData( data[found] );
                                        data.splice(found, 1);
                                    }
                                }
                                for(let i = 0; i < data.length; i++){
                                    $scope.Favorites.push(data[i]);
                                }

                                setMainViewProperties();
                                $scope.generateList();
                                defer.resolve();
                            },function(){
                                defer.reject();
                            });
                            return defer.promise;

                        }
                    };
                    $scope.favoritesintervall = f_Interval.registerInterval(intervalConfig);
                }

            }


            $scope.init = function () {
                $scope.Favorites = Favorites;
               // $scope.Favorites.$dispatch('refresh-values');

                $scope.generateList();
                initFavoritesUpdateInterval();
                setMainViewProperties();
                /* initial set Buttons, edit + sort */
                $scope.$UI = {sortMode:false};
                function resetVars(){
                    if($scope.$UI.editItemBefore && $scope.$UI.editItem && $scope.$UI.editItemBefore !== $scope.$UI.editItem)
                    {
                        /* Needed lines for reverting favorite icon on edit favorites page.

                           First the favorite's icon is changed and accepted. At that moment
                           favorite's watch activates and changes icon from old (or none) to the new.
                           An user then presses revert (zürucksetzen) and watch is activated again
                           but because it did set the new icon in previous run, now it does not
                           detect any change and does not revert the favorite's icon.

                           So this 'hack' changes image name from new to old, watch then activates,
                           detects changed name and reverts name to the old one. */
                        if ($scope.$UI.editItemBefore.ImageName !== $scope.$UI.editItem.ImageName) {
                            $scope.$UI.editItem.ImageName = $scope.$UI.editItemBefore.ImageName;
                        }

                        $scope.$UI.editItem.$UI.changed = true;
                    }
                    if($scope.$UI && $scope.$UI.editItem && $scope.$UI.editItem.$UI)
                    {
                        $scope.$UI.editItem.$UI.editMode = false;
                    }

                }

                $scope.buttons = {
                    init : {
                        'sortButton': function () {
                           // $scope.sortmode = true;
                            $scope.$UI.sortMode = true;
                            if (xCenterConfig.interval.homescreenFavoriteValues > 0) {
                                f_Interval.pauseIntervalByAppId($scope.favoritesintervall);
                            };
                            $scope.$emit('loading-start');

                            __Favorite.$getAll().$then(function(data){
                                $scope.updateFavorites(data);

                                viewMenuBarService.setButtons($scope.buttons.sortMode);
                                $scope.$emit('loading-stop');
                            })


                            // Todo: Stop running intervals
                        },
                        'editButton': function () {
                           // $scope.editMode = true;
                            // Todo: Stop running intervals
                            $scope.$UI.editMode = true;
                            $scope.$UI.deleteList = [];
                            $scope.$UI.revertFavorites = angular.copy($scope.Favorites);
                            //
                            viewMenuBarService.setButtons($scope.buttons.editMode);
                            if (xCenterConfig.interval.homescreenFavoriteValues > 0) {
                                f_Interval.pauseIntervalByAppId($scope.favoritesintervall);
                            };

                        }
                    },
                    editMode : {
                        'clearButton': function () {
                           // $scope.sortmode = true;
                            $scope.$emit('loading-start');
                            resetVars();
                            __Favorite.$getAll({'WithDetails':true}).$then(function(data){
                                $scope.Favorites = data;
                                $scope.generateList();
                                if (xCenterConfig.interval.homescreenFavoriteValues > 0) {
                                    f_Interval.restartIntervalByAppId($scope.favoritesintervall,true);
                                };
                                viewMenuBarService.setButtons($scope.buttons.init);
                                $scope.$emit('loading-stop');
                            });
                            if($scope.$UI.editItem){
                                $scope.$UI.editItem.$UI.editMode = false;
                            }
                            $scope.$UI.editMode = false;



                        },
                        'saveButton': function () {
                            $scope.$UI.editMode = false;
                            $scope.$emit('loading-start');
                            resetVars();
                            var list = [];
                            for(var i = 0; i < $scope.Favorites.length; i++)
                            {
                                if($scope.Favorites[i].$UI.markForDelete == true)
                                {
                                    $scope.Favorites[i].$UI.loading = true;

                                    list.push( $scope.Favorites[i].$destroy().$asPromise());
                                }else if( $scope.Favorites[i].$UI.changed ){
                                    $scope.Favorites[i].$UI.loading = true;
                                    var t = $scope.Favorites[i];
                                    list.push( $scope.Favorites[i].$save().$then(function(){
                                        t.$UI.loading = false;
                                        t.$UI.changed = false;
                                    }).$asPromise());
                                }

                            }
                          $q.all(list).then(function(){
                              if (xCenterConfig.interval.homescreenFavoriteValues > 0) {
                                  f_Interval.restartIntervalByAppId($scope.favoritesintervall,true);
                              };
                              viewMenuBarService.setButtons($scope.buttons.init);
                              $scope.$emit('loading-stop');
                          })




                        }
                    },
                    sortMode : {
                        'sortButtonGreen' : true,
                        'sortButton' : function(){
                            $scope.$emit('loading-start');
                            $scope.$UI.sortMode = false;
                            // Todo: Start running intervals

                            __Favorite.$getAll({'WithDetails':true}).$then(function(data){
                                $scope.$UI.editMode = false;
                                $scope.updateFavorites(data);
                               /* for(var i = 0; i < $scope.Favorites.length; i++)
                                {
                                    $scope.Favorites[i].$dispatch('prepareFavorite');
                                }*/
                               // $scope.Favorites.$dispatch('refresh-values');
                               // $scope.Favorites.$dispatch('refresh-values');;

                                if (xCenterConfig.interval.homescreenFavoriteValues > 0) {
                                    f_Interval.restartIntervalByAppId($scope.favoritesintervall,true);
                                };

                                viewMenuBarService.setButtons($scope.buttons.init);
                                $scope.$emit('loading-stop');
                            })

                        }

                    }
                }
                viewMenuBarService.setButtons($scope.buttons.init);

            }


            $scope.selectDeviceForOutsideTemperature = function () {
                var outsideTemperatureDeviceTypes = ENUM.getDeviceTypesByFilter(9);
                // Map Enums to Array of DeviceTypes
                outsideTemperatureDeviceTypes = outsideTemperatureDeviceTypes.map(x => x.EnumValueKeyNumber);
                outsideTemperatureDeviceTypes.push(99);
                outsideTemperatureDeviceTypes.sort((a, b) => {
                    return a - b;
                });
                
                $scope.$emit('loading-start');
                var _API = new API();
                return _API
                    .Device
                    .GetDevicesByFilter({WithDetails: true, WithChildDevices: true, Recursive: true, DeviceTypes: [2,5,40], MenuEntries: []})
                    .$promise
                    .then(function (data) {
                        if (data) {
                            for (var i = 0; i < data.length; i++) {

                                data[i] = __Device.$buildRaw(data[i]);
                            }
                            $scope.$emit('loading-stop');

                            var filterOptions = {

                                MenuEntry: {
                                    emptyRooms: false,
                                    emptyRoomsButton: false,
                                    selectable: false,
                                    withChildIds: false,
                                    selected: undefined
                                },

                                Device: {
                                    // Later on set via Enum
                                    show: outsideTemperatureDeviceTypes,
                                 //   selectable: true,
                                    selectable: 'single',
                                    list : data
                                // list: $scope.AllDevices
                                },
                                saveOnSelect: true,
                                inline: false,
                                title: 'MODAL_OutsideTemperatureTitle',
                                bigTitle : 'MODAL_OutsideTemperatureTitleBig',
                                bigTitleIcon : 'geraete'

                            };
                            $scope.ModalActive = true;
                            deviceRoomPickerModal(filterOptions).then(function (modal) {
                                modal['close'].then(function (data) {
                                    // Close by close button => return
                                    if(!data){ return; }

                                    // Close by close button => return
                                    // data.Device[0].$dispatch('build-additional-datapoints');
                                    var dpid = xCenterConfig.wellKnownDatapoints.outsideTemperature;

                                    if(!$scope.Favorites.$getByUIID('OutsideTemperature'))
                                    {
                                        $scope.aussenTemp = __Favorite.$buildRaw({
                                            DatapointConfigId: dpid,
                                            DeviceId: data.Device[0].DeviceId,
                                            DisplayName: "Solltemperatur",
                                            ImageName: "temperatur-sensor",
                                            Position: -1,
                                            ShowOnStartScreen: true,
                                            UITags: {
                                                '$type': "System.Collections.Generic.List`1[[System.String, mscorlib]], mscorlib",
                                                '$values': ['UIID:OutsideTemperature']
                                            },

                                            $type: "BMS.Shared.Model.System.FavoriteDatapoint, BMS.Shared"
                                        })
                                    .$save().$then(function(){
                                            $scope.Favorites.$add($scope.aussenTemp);
                                        });
                                    }else{
                                        $scope.aussenTemp = $scope.Favorites.$getByUIID('OutsideTemperature');
                                        $scope.aussenTemp.DatapointConfigId = dpid;
                                        $scope.aussenTemp.DeviceId = data.Device[0].DeviceId;
                                        $scope.aussenTemp.Datapoint.DatapointValue.DeviceId = data.Device[0].DeviceId;
                                        $scope.aussenTemp.$UI.Device = data.Device[0];
                                        $scope.aussenTemp.$save().$then(function(){
                                            $scope.aussenTemp.$refresh();
                                        });

                                    }


                                });
                            });

                            return $filter('orderBy')(data, ['+DeviceType', '+Name']);
                        }
                    }
                );

            }


            $scope.addRow = function () {
                if ($scope.menu) {
                    var lastPost = $scope.menu[$scope.menu.length - 1].Position + 1;
                    $scope.lastMaxPosition = lastPost+5;
                    for (var i = lastPost; i < (lastPost + 5); i++) {
                        $scope.menu.push(
                            {
                                "NewFavorite": [],
                                "Favorite": [],
                                "Position": i
                            }
                        );
                    }
                }
            }


            $scope.isWellKnownFavorite = function (f) {
                if (conf_wellKnownObjects['Favorites'].hasOwnProperty(f.FavoriteId)) {
                    return conf_wellKnownObjects['Favorites'][f.FavoriteId];
                }
                return false;
            }

            // Mark Favorite for Delete Call
            $scope.deleteItemFromList = function (Favorite) {
                Favorite.$UI.markForDelete = true;
            }

            // Filter List by is On Startscreen
            $scope.isOnStartscreen = function (o) {
                if (o.ShowOnStartScreen == true) {
                    return true;
                }
                return false;
            }

            // Filter List by is Not On Startscreen
            $scope.isNotOnStartscreen = function (o) {
                if (o.ShowOnStartScreen == false) {
                    return true;
                }
                return false;
            }


            $scope.SortOptions_StartScreen =
            {

                beforeDrag : function(e){
                    // console.log(e);
                    if(e.$modelValue.Favorite)
                    {
                        return false;
                    }
                    return true;
                },
                accept: function(source, dest, destIndex)
                {

                    // Drop only allowed on List

                    if( dest.$type != 'uiTreeNodes')
                    {
                        //console.log('uiTReeNodes say no!');
                        return false;
                    }
                    // If Element is coming from the other Tree (NotOnStartScreen)
                    if( dest.$parent
                        && dest.$parent.$type == 'uiTree'){
                       // console.log('its a uiTree');
                        return false;
                    }else if(
                        (dest.$parent && dest.$parent.$modelValue.Favorite.length == 0 )||
                        (dest.$modelValue && dest.$modelValue.length == 0)
                    )
                    {

                       // console.log('its possible');
                        return true;
                    }else{
                       // console.log('something else',dest);
                        return false;
                    }

                },dropped:
                function(e)
                {

                    $scope.$emit('loading-start');
                  //  console.log(e);
                    // console.log('dropped by OnStartScreen');

                    var showOnStartScreen;
                    var newPos;
                    var item;

                    if(e.source.nodesScope.$treeScope.$id != e.dest.nodesScope.$treeScope.$id)
                    {

                        // O.k. we sorting from OnStartScreen to NotOnStartScreen
                        newPos = ( e.dest.index ) ;
                       // console.log('OnStartScreen to Not');
                        // des index is not working. check via indexOf
                        var index = e.dest.index;//e.dest.nodesScope.$modelValue.indexOf(e.source.nodeScope.$modelValue);
                        item = e.source.nodeScope.$modelValue;// e.dest.nodesScope.$modelValue[index];
                        if(e.dest.nodesScope.$modelValue.length == 0)
                        {
                            // No Elemente on NotOnStartScreen
                            newPos = 0;
                        }else if(index <= -1 || index == 0)
                        {
                            // moved to first position - no specual logic here
                            // NewPos should be 0
                            newPos = 0;

                        } else {
                            //take previsous element and increase position by 1
                            newPos = e.dest.nodesScope.$modelValue[index -1 ].Position +1;
                            console.warn('newPosition: ' + newPos);
                        }

                        showOnStartScreen = false;
                    }else{
                       // console.log('OnStartScreen Only Sort');
                        showOnStartScreen = true;
                        newPos = e.dest.nodesScope.$parent.$modelValue.Position ;
                        item = e.dest.nodesScope.$modelValue[e.dest.index];
                    }

                    if(!item){
                        // console.log('No Item for PositionChange');
                        $scope.$emit('loading-stop');
                        return;
                    }

                    // Get Favorite from Our $scope.Favorites.
                    var found = $scope.Favorites.findIndex(a => {
                        return a.FavoriteId == item.FavoriteId;
                    });
                    var saveItem =  $scope.Favorites[found];
                    saveItem.Position = newPos;
                    saveItem.ShowOnStartScreen = showOnStartScreen;

                    saveItem.$save().$then(function(data){

                        __Favorite.$getAll({'WithDetails':true}).$then(function(data){
                            var str = 'After saved: ';
                            e.dest.nodesScope.$modelValue.forEach(function(favorite) {
                                var savedFavorite = ($filter('filter')( data , {FavoriteId : favorite.FavoriteId}, true))[0];
                                if (savedFavorite) {
                                    favorite.Position = savedFavorite.Position;
                                    str += favorite.DisplayName + ':' + favorite.Position + ' ';
                                }
                            });


                            $scope.updateFavorites(data,true);

                            $scope.$emit('loading-stop');
                        })
                    },function(){
                        __Favorite.$getAll({'WithDetails':true}).$then(function(data){
                            $scope.updateFavorites(data,true);
                            $scope.$emit('loading-stop');
                        })

                    })

                }
            };
            $scope.SortOptions_NotStartScreen =
            {
                placeholderClass : 'grid-item',
                accept: function(source, dest, destIndex)
                {
                    return true;
                    // Drop only allowe on List
                    if(dest.$type !='uiTreeNodes')
                    {
                        //return false;
                    }

                    if( dest.$parent
                        && dest.$parent.$type == 'uiTree' )
                    {
                        return true;
                    }else{
                       // return false;
                    }
                    return true;

                },

                dropped:
                    function(e)
                    {
                        if((e.source.nodesScope.$treeScope.$id !== e.dest.nodesScope.$treeScope.$id)
                            && e.dest.index === 0)
                        {
                            // Bug in the ui-tree. Moving a favorite from NotOnStartScreen to OnStartScreen
                            // and the dest index is 0 instead of -1.
                            e.dest.index = -1;
                        }

                        e.source.nodesScope.$modelValue.forEach(function(node) {
                            if (!node.$$hashKey) {
                                console.warn('Favorite source:' + node.DisplayName + ' has no $$hashKey!');
                                console.warn('Have you used the "trackby" ng-repeat feature? It causes bugs in dest index!');
                                console.warn('For more information see issues #302, #760 and #146 on github.');
                            }
                        });
                        e.dest.nodesScope.$modelValue.forEach(function(node) {
                            if (!node.$$hashKey) {
                                console.warn('Favorite dest:' + node.DisplayName + ' has no $$hashKey!');
                                console.warn('Have you used the "trackby" ng-repeat feature? It causes bugs in dest index!');
                                console.warn('For more information see issues #302, #760 and #146 on github.');
                            }
                        });

                        $scope.FavoritesNotOnStartScreen = $filter('orderBy')($scope.FavoritesNotOnStartScreen, '+Position');

                        $scope.$emit('loading-start');

                        var showOnStartScreen;
                        var SortedFavoriteId = e.source.nodeScope.$modelValue.FavoriteId;
                        printPositionInfo('After dropped:');


                        var indexOfMovedFavorite = $scope.Favorites.findIndex(a => {
                            return a.FavoriteId === SortedFavoriteId;
                        });
                        var movedFavoriteToSave =  $scope.Favorites[indexOfMovedFavorite];
                        var destIndex = e.dest.index;

                        var newPos;

                        // Now find index in destList
                        if(e.source.nodesScope.$treeScope.$id != e.dest.nodesScope.$treeScope.$id)
                        {
                            // O.k. we sorting from  NotOnStartScreen to OnStartScreen
                            newPos = (e.dest.nodesScope.$parent.$modelValue.Position ) ;
                            showOnStartScreen = true;
                          //  console.log('NOTOnStartScreen To StartScreen');

                        }else{
                           // console.log('NOTOnStartScreen Only Sort');
                            //= $scope.FavoritesNotOnStartScreen.Position ;
                            if($scope.FavoritesNotOnStartScreen.length === 1)
                            {
                                // Only One Element (thisElement)
                                // so don't do anything
                                $scope.$emit('loading-stop');
                                return;
                            }

                            if(destIndex <= -1){
                                newPos = 0;
                            } else {
                                  /* Moving chosen favorite from left to right */
                                if (e.source.index < e.dest.index) {
                                    newPos = $scope.FavoritesNotOnStartScreen[destIndex].Position +1;


                                }

                                /* Moving chosen favorite from right to left */
                                else if (e.source.index > e.dest.index) {
                                    newPos = $scope.FavoritesNotOnStartScreen[destIndex].Position;


                                }


                                else if (e.source.index === e.dest.index) {
                                    // Do nothing
                                    movedFavoriteToSave = undefined;
                                }
                                else {
                                    console.warn('Conditions for indexes not met!');
                                }
                            }

                            showOnStartScreen = false;
                        }
                        if(!movedFavoriteToSave){
                            //console.log('No Item for PositionChange');
                            $scope.$emit('loading-stop');
                            return;
                        }

                        movedFavoriteToSave.Position = newPos;
                        movedFavoriteToSave.ShowOnStartScreen = showOnStartScreen;
                    //    console.log('NOTSTARTSCREEN:Favorite Position is'+newPos);

                        movedFavoriteToSave.$save().$then(function(data){

                            __Favorite.$getAll({'WithDetails':true}).$then(function(data){
                                var str = 'After saved: ';
                                $scope.FavoritesNotOnStartScreen.forEach(function(favorite) {
                                    var savedFavorite = ($filter('filter')( data , {FavoriteId : favorite.FavoriteId}, true))[0];
                                    if (savedFavorite) {
                                        favorite.Position = savedFavorite.Position;
                                        str += favorite.DisplayName + ':' + favorite.Position + ' ';
                                    }
                                });

                                $scope.updateFavorites(data,true);
                                $scope.$emit('loading-stop');
                            });
                        },function(){
                            __Favorite
                                .$getAll()
                                .$then(function(data){
                                $scope.updateFavorites(data,true);
                                $scope.$emit('loading-stop');
                            });
                        });
                    }
            };


            function printPositionInfo(header) {
                var str = header + ' ';
               $scope.FavoritesNotOnStartScreen.forEach(function(favorite) {
                    str += favorite.DisplayName + ':' + favorite.Position + ' ';
                });
            }



            $scope.init();
        }]);
